import type { NavItem } from "@/lib/nav";

export const KONTAKTE_CHILD_ITEMS: NavItem[] = [
  {
    key: "kunden",
    label: "Kunden",
    href: "/kontakte/kunden",
    internal: true,
    aclHref: "/kontakte.html",
  },
  {
    key: "lieferanten",
    label: "Lieferanten",
    href: "/kontakte/lieferanten",
    internal: true,
    aclHref: "/kontakte.html",
  },
];
